export class cookieManager {
  static hasCookie = (name: string): boolean => {
    const key = name + '=';
    return document.cookie.indexOf(key) >= 0;
  };
}
